import links from "@/links/links";
import qs from "qs";

export default {
  actions: {
    FETCH(buildingId) {
      let processedQueryParams = {};

      processedQueryParams.pagination = false;
      processedQueryParams[`order[lastname]`] = "asc";
      return this.get(links.BUILDING_OWNER_FETCH(buildingId), {
        params: processedQueryParams,
        paramsSerializer: params => {
          return qs.stringify(params);
        },
        dataKey: "hydra:member",
      });
    },
    QUERY_FETCH(buildingId, queryParams) {
      let processedQueryParams = {};

      processedQueryParams[`order[lastname]`] = "asc";
      processedQueryParams.page = queryParams.page;
      processedQueryParams.itemsPerPage = queryParams.itemsPerPage;

      return this.get(links.BUILDING_OWNER_FETCH(buildingId), {
        params: processedQueryParams,
        paramsSerializer: params => {
          return qs.stringify(params);
        },
        dataKey: "hydra:member",
      });
    },
    QUERY_FETCH_FOR_BUILDING_CATALOG(queryParams) {
      let processedQueryParams = {};

      // order
      if (queryParams && queryParams.sort) {
        processedQueryParams[`order[${queryParams.sort.by}]`] = queryParams.sort.dir.toLowerCase();
      }

      // page
      processedQueryParams["building.id"] = queryParams.buildingId;
      processedQueryParams.page = queryParams.page;
      processedQueryParams.itemsPerPage = queryParams.itemsPerPage;

      // search
      processedQueryParams.name = queryParams.searchParams;

      return this.get(links.BUILDING_OWNERS_BUILDING_CATALOG(), {
        params: processedQueryParams,
        paramsSerializer: params => {
          return qs.stringify(params);
        },
        dataKey: "hydra:member",
      });
    },
    GET(id) {
      return this.get(links.BUILDING_OWNER_GET(id));
    },
    REGISTER(item) {
      return this.post(links.REGISTER_BUILDING_OWNER(), item);
    },
    POST(item) {
      return this.post(links.BUILDING_OWNER_POST(), item);
    },
    PUT(item) {
      return this.put(links.BUILDING_OWNER_PUT(item.id), item);
    },
    // FIXME: GET??
    CUSTOM_DELETE(id) {
      return this.get(links.BUILDING_OWNER_CUSTOM_DELETE(id));
    },
    // ???: agencyId, token, refreshToken ??
    BULK_DELETE(items, buildingId, agencyId, token, refresh_token) {
      return this.post(
        links.BUILDING_OWNER_BULK_DELETE(),
        {
          items: items,
          building_id: buildingId,
          agency_id: agencyId,
          token: token,
          refresh_token: refresh_token,
        },
        {
          save: false,
        }
      );
    },
    IMPORT(items, buildingId, agencyId, token, refresh_token) {
      return this.post(
        links.BUILDING_OWNER_IMPORT(),
        {
          items: items,
          building_id: buildingId,
          agency_id: agencyId,
          token: token,
          refresh_token: refresh_token,
        },
        {
          save: false,
        }
      );
    },
    ADD_EDIT_COOWNER_PROCESS(item) {
      return this.post(links.BUILDING_OWNER_ADD_EDIT_PROCESS(), item);
    },

    CHECK_IF_DEPART_BUILDING_LOT_CAN_BE_EXECUTED(data) {
      return this.post(
        links.CHECK_IF_DEPART_BUILDING_LOT_CAN_BE_EXECUTED(),
        {
          old_owner_id: data.oldOwnerId,
          new_owner_id: data.newOwnerId,
        },
        {
          save: false,
        }
      );
    },
    EXECUTE_DEPART_BUILDING_LOT(data) {
      return this.post(
        links.EXECUTE_DEPART_BUILDING_LOT(),
        {
          old_owner_id: data.oldOwnerId,
          new_owner_id: data.newOwnerId,
          building_lots_to_sale: data.buildingLotsToSale,
        },
        {
          save: false,
        }
      );
    },
    REGISTER_GET_BUILDING_OWNERS(meetingId) {
      let params = {};
      if (meetingId) {
        params["meeting_id"] = meetingId;
      }
      return this.get(links.BUILDING_OWNER_MEETING_REGISTER() + "?" + qs.stringify(params));
    },
    SET_LRE_AGREEMENT(items) {
      return this.post(links.BUILDING_OWNER_SET_LRE_AGREEMENT(), items);
    },
    GET_TOTAL_VOTING_RIGHT_PARTS(buildingId) {
      return this.get(links.BUILDING_OWNERS_TOTAL_VOTING_RIGHT_PARTS(buildingId));
    },
  },
};
